import { ApolloProvider } from '@apollo/client';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';

import { AuthProvider } from './context/AuthContext';
import { LoaderProvider } from './context/LoaderContext';
import { ProjectDetailProvider } from './context/ProjectContext';
import { ProjectVersionHistoryProvider } from './context/VersionHistoryContext';
import { ProjectWarningProvider } from './context/ProjectWarningContext';
import { TeamMembersProvider } from './context/TeamMembersContext';
import { WorkspaceInviteProvider } from './context/WorkspaceInviteContext';
import { WorkspaceProvider } from './context/WorkspaceContext';
import APOLLO_CLIENT from './lib/apollo';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = document.getElementById('root');
const rootElement = createRoot(root);

rootElement.render(
  <StrictMode>
    <ApolloProvider client={APOLLO_CLIENT}>
      <LoaderProvider>
        <WorkspaceInviteProvider>
          <AuthProvider>
            <WorkspaceProvider>
              <ProjectDetailProvider>
                <ProjectWarningProvider>
                  <TeamMembersProvider>
                    <ProjectVersionHistoryProvider>
                      <App />
                    </ProjectVersionHistoryProvider>
                  </TeamMembersProvider>
                </ProjectWarningProvider>
              </ProjectDetailProvider>
            </WorkspaceProvider>
          </AuthProvider>
        </WorkspaceInviteProvider>
      </LoaderProvider>
    </ApolloProvider>
  </StrictMode>,
);

reportWebVitals();
